import { Box, IconButton, Stack } from '@mui/material';
import React from 'react';

interface ControlBarButtonProps {
  icon: React.ReactNode;
  active?: boolean;
  label?: string;
  onClick?: () => void;
}

function ControlBarButton({
  icon,
  active = false,
  label = '',
  onClick = () => { },
}: Readonly<ControlBarButtonProps>) {
  return (
    <Stack justifyContent='center' alignItems='center'>
      <Box marginBottom='4px'>
        <IconButton
          sx={{
            borderRadius: '76px',
            padding: '8px',
            background: (theme) => {
              return active ? theme.palette.teal.main : '#181818';
            },
            '&:hover': {
              background: (theme) => theme.palette.neutralBlackBg[900],
            },
          }}
          onClick={onClick}
        >
          {icon}
        </IconButton>
      </Box>
      <Box
        sx={{
          color: (theme) => theme.palette.neutralBlackBg[50],
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '500',
          lineHeight: '125%',
        }}
      >
        {label}
      </Box>
    </Stack>
  );
}

export default ControlBarButton;
